import * as React from 'react';
import { hot } from 'react-hot-loader';
import { Row, Col } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { logout } from '../../../helpers/asureid';

const AsureIdPage = () => {
  React.useEffect(() => {
    // Trigger login when component mounts
    const initiateLogout = async () => {
      try {
        await logout();
      } catch (error) {
        console.error('Failed to redirect to login:', error);
      }
    };

    initiateLogout();
  }, []); // Empty dependency array means this runs once on component mount

  return (
    <>
      <Row>
        <Col>
          <h3 className="pt-3">
            <FormattedMessage id="ASURE_ID_REDIRECT" />
          </h3>
          <p className="mt-2">
            <FormattedMessage
              id="REDIRECTING_TO_LOGOUT"
              defaultMessage="Redirecting to Asure ID logout..."
            />
          </p>
        </Col>
      </Row>
    </>
  );
};

export default hot(module)(AsureIdPage);
